<!-- @format -->

<template>
  <TableFull v-model="control" :headers="headers" :items="itemWarehouse" dense class="w-full">
    <template v-slot:actions="{ item }">
      <TheToolTip label="Ver Depósito">
        <TableIconButton icon="fa-arrow-right-to-city" @click="navigate('depositUpdate', { id: item.idWarehouse }, true)" />
      </TheToolTip>
    </template>
  </TableFull>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { get } from '@/crud'
import { useNavigation } from '@/composables/useNavigation'
import { useFormat } from '@/composables/useFormat'
//  Composables
const { navigate } = useNavigation()
const { formatMoneyS } = useFormat()
// Props
const props = defineProps({
  id: [String, Number],
})
// Controller
const api = 'itemWarehouse'

const itemWarehouse = ref([])

const control = ref({
  page: 1,
  limit: 20,
  pages: 0,
  total: 0,
  order: [{ direction: 'ASC', column: 'type', name: 'Tipo', table: 'warehouse' }],
})

const headers = ref([
  { title: 'Tipo', field: 'typeName', table: 'warehouse', orderField: 'type', itemClass: 'w-2/12' },
  { title: 'Depósito', field: 'warehouseName', table: 'warehouse', orderField: 'name', itemClass: '!text-wrap' },
  { title: 'QTD', field: 'quantity', itemClass: 'w-1/12' },
  { title: 'Preço Médio', field: 'avgPrice', itemClass: 'w-2/12', format: formatMoneyS },
  { title: 'Último Preço', field: 'lastPrice', itemClass: 'w-2/12', format: formatMoneyS },
  { title: 'Ações', field: 'actions', itemClass: 'w-1/12', disableOrder: true, headerClass: 'justify-center' },
])

// Methods
const loadItems = async () => {
  const filters = [
    {
      column: 'idItem',
      value: props.id,
      operator: '=',
    },
  ]

  const query = {
    params: {
      page: control.value.page,
      limit: control.value.limit,
      order: control.value.order,
      filters,
    },
  }

  const raw = await get(api, query)
  itemWarehouse.value = raw.data
  control.value.pages = Math.ceil(raw.total / control.value.limit)
  control.value.total = raw.total
}
// Watchers
watch(
  () => props.id,
  () => {
    loadItems()
  },
  { deep: true }
)

watch(
  () => control.value,
  () => {
    loadItems()
  },
  { deep: true }
)

// Life Cycle
onMounted(() => {
  loadItems(1)
})
</script>
